import { useState, useEffect, useRef } from "react"
import {
  Backdrop,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from "@mui/material"
import { RootState } from "@/core/app/store"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { useMyNavigation } from "@/hooks/useMyNavigation"
import { safeCloseWindow } from "@/core/app/CloseTabContext"

export const UDOpenCase = () => {
  const { isShowProgress, ProgressMsg, openMode } = useAppSelector(
    (state: RootState) => state.clinicalService,
  )

  const [alert, setAlert] = useState(false)
  const navigate = useMyNavigation()

  // Get Treatment Infos and zip file names
  // useEffect(() => {
  //   console.log("getTreatmentInfos ::")
  //   dispatch(setCurCaseMode("WeDesign"))
  //   dispatch(setCurLeftPage(""))
  //   stagingManager.clearWasmStageData()
  //   dispatch(setStageShowType(""))
  //   dispatch(setOpenHistorySplitView(false))
  //   caseManagement.closeCase()
  //   dispatch(resetCase())
  //   dispatch(setSwitchViewEdit(false))
  //   dispatch(setIsCasePreview(true)) // default is preview only
  //   setAlert(false)

  //   // Get zip file names
  //   dispatch(
  //     fetchFileList({
  //       patientId,
  //       caseId,
  //     }),
  //   )
  //   dispatch(fetchClinicalSettings())

  //   dispatch(setRefinementReady(false))
  //   // dispatch(setIsShowProgress(true))
  //   // dispatch(setProgressMsg("Start download case..."))

  //   return () => {
  //     dispatch(resetCase())
  //     dispatch(setIsShowProgress(false))
  //   }
  // }, [])

  useEffect(() => {
    if (openMode === "needdopresetupbyudesign") {
      setAlert(true)
    }
  }, [openMode])

  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      open={isShowProgress}
    >
      <Box id={"PrograssBar"} sx={{ width: "40%" }}>
        {ProgressMsg}
        <LinearProgress />
      </Box>

      <Dialog
        sx={{
          margin: "auto",
          display: "flex",
          maxWidth: 510,
          height: 330,
          alignSelf: "center",
          justifySelf: "center",
        }}
        open={alert}
      >
        <DialogTitle
          sx={{
            fontsize: "20px",
            fontstyle: "normal",
            fontweight: 500,
            lineheight: "160%",
            letterspacing: " 0.15px",
          }}
        >
          Self-planned cases must complete pre-setup in uDesign 10
        </DialogTitle>
        <DialogContent
          sx={{
            fontsize: "16px",
            fontstyle: "normal",
            fontweight: 400,
            lineheight: "150%",
            letterspacing: "0.15px",
          }}
        >
          To view or modify a self planned case in uDesign Cloud, you must first{" "}
          <strong>open the case in uDesign desktop software</strong> and
          complete tooth identification and segmentation.
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              safeCloseWindow()
              return
            }}
            sx={{
              textTransform: "uppercase",
            }}
            size="medium"
            variant="contained"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Backdrop>
  )
}
